export default {
  cancelDialog: {
    title: 'Cancel “{{studyName}}”?',
    description:
      "Sims won't be submitted. Your meshes stay in MeshGen — nothing is deleted.",
    alreadyProduced: 'Already produced (preserved)',
    openInMeshGen: 'Open in MeshGen',
    keepStudy: 'Keep study',
    confirmCancel: 'Cancel study & keep meshes',
  },
  completionDialog: {
    eyebrow: 'Run simulations',
    title_one: 'Submit {{count}} design point to the solver?',
    title_other: 'Submit {{count}} design points to the solver?',
    description:
      'You can return to mesh anytime, but new sim runs will use the meshes attached below.',
    facesNamed: '{{cells}} · {{faces}} named',
    needsMeshing: 'needs meshing — will be skipped',
    estimateLabel: 'Estimated cost · time',
    keepMeshing: 'Keep meshing',
    runOnDps_one: 'Run simulations on {{count}} DP',
    runOnDps_other: 'Run simulations on {{count}} DPs',
  },
  switcher: {
    ariaLabel: 'Design points',
    moreCount: '+{{count}} more',
    nextPending: 'Next pending',
  },
  toasts: {
    cancelStudyPending:
      'Cancel-study endpoint not yet available — UI ready, awaiting backend.',
    markDpPending:
      'Mark-DP-complete endpoint not yet available — advancing to next pending.',
  },
  journey: {
    ariaLabel: 'Study journey',
    remeshTooltip_one: '{{count}} DP awaiting re-mesh',
    remeshTooltip_other: '{{count}} DPs awaiting re-mesh',
    remeshBadge: '{{count}} re-mesh',
    youAreHere: 'you are here',
    skipped: 'Skipped',
    stepMeshSub: 'Health + settings',
    stepSimulateSub: 'Parameters + run',
    stepResultsSub: 'Analysis',
  },
  status: {
    notStarted: 'Not started',
    meshing: 'Meshing',
    meshReady: 'Mesh ready — name faces',
    facesDone: 'Ready',
    failed: 'Failed',
  },
  completionBar: {
    thisDp: 'This DP',
    meshProduced: 'Mesh produced',
    allFacesNamed: 'All faces named',
    markDpComplete: 'Mark DP complete',
    studyProgress: 'Study progress',
    completeAndRun: 'Complete & run simulations',
  },
  progressList: {
    colDp: 'DP',
    colGeometry: 'Geometry / variant',
    colMesh: 'Mesh',
    colFaceNaming: 'Face naming',
    colStatus: 'Status',
    colAction: 'Action',
    failedInMesh: 'failed in mesh',
    namingInProgress: 'naming in progress',
    facesNamed: '{{faces}} named',
    allNamed: 'all named',
    currentlyOpen: 'currently open',
    reopen: 'Re-open',
    openInMeshGen: 'Open in MeshGen',
    viewInMeshGen: 'View in MeshGen',
  },
  resumeCard: {
    ariaLabel: 'Resume meshing — {{studyName}}',
    eyebrow: 'Resume meshing',
    paused: 'paused {{ago}}',
    expiresIn: 'expires in {{time}}',
    remaining_one: '{{remaining}} of {{total}} geometry remaining',
    remaining_other: '{{remaining}} of {{total}} geometries remaining',
    autoQueue: 'sims will queue automatically when meshing completes',
    resumeNextPending: 'Resume next pending',
    cancelStudy: 'Cancel study…',
  },
  tree: {
    removeFromRun: 'Remove mesh from run',
    addToRun: 'Add mesh to run',
    collapse: 'Collapse',
    expand: 'Expand',
    remesh: 'Re-mesh',
    mesh: 'Mesh',
    view: 'View',
    review: 'Review',
    otherSimType: 'Other sim type',
    notMeshedYet: 'Not meshed yet',
    meshLabel: 'Mesh',
    refinementLabel: 'Refinement',
  },
  contextBanner: {
    returnToStudy: 'Return to study',
    studyMode: 'Study mode',
    geometryOf: 'geometry {{index}} of {{total}}',
    nameFaceToCommit: 'name 1 face to commit',
    ready: 'ready',
  },
  draftChrome: {
    geometryNotStarted: 'Not meshed',
    geometryLoading: 'Checking…',
    geometryProcessing: 'Preparing',
    geometryAwaitingApproval: 'Awaiting approval',
    geometryError: "Can't be meshed",
    geometryMeshing: 'Meshing',
    geometryCompleted: 'Ready',
    geometryFailed: 'Failed',
    fallbackStudyTitle: 'Study',
    backToStudy: 'Back to study',
    meshedProgress: '{{done}} of {{total}} meshed',
    geomLabel: 'geom {{index}} · {{status}}',
    allMeshed: 'All geometries meshed.',
    meshAllToContinue: 'Mesh every geometry to continue.',
    waitForPreparation_one:
      'Waiting on {{count}} geometry that is still being prepared or needs attention.',
    waitForPreparation_other:
      'Waiting on {{count}} geometries that are still being prepared or need attention.',
    continueToSimulate: 'Continue to Simulate',
  },
  studyChrome: {
    loadingContext: 'Loading study context…',
    errorContext:
      "Couldn't load the study context for this DP — the workspace is usable but study chrome is hidden.",
    returnToStudy: 'Return to study',
  },
  timeoutCard: {
    ariaLabel: 'Meshing session timed out',
    title: 'Meshing session timed out',
    badge: 'failed · expired',
    body_one:
      'This study sat in "awaiting meshing" for 7 days, so we paused it. Your {{count}} completed mesh is safe in MeshGen. You can pick up where you left off by starting a new study seeded from them — a mesh-in study reuses the meshes you already finalized.',
    body_other:
      'This study sat in "awaiting meshing" for 7 days, so we paused it. Your {{count}} completed meshes are safe in MeshGen. You can pick up where you left off by starting a new study seeded from them — a mesh-in study reuses the meshes you already finalized.',
    startNewStudy: 'Start a new study from these meshes',
    viewFinishedMeshes: 'View finished meshes',
    archiveStudy: 'Archive study',
  },
} as const;
